import React, { Component } from 'react';

class SPAXFFooter extends Component<any> {
  props: any;
  state: any;
  fetchHtml: any;
  constructor(props: any) {
    super(props);

    this.state = {
      footerContent: null,
      scripts: '',
    };
  }

  fetchExternalHTML = async () => {
    const response = await fetch(
      '/content/experience-fragments/workplace/page_structure_xfs/footer-experience-fragment/master.html',
    );
    const xFooterContent = await response.text();
    const spaFooter = xFooterContent.substring(
      xFooterContent.indexOf('<body class="xf-web-container">') + 31,
      xFooterContent.indexOf('</body'),
    );
    this.setState({ footerContent: spaFooter });
    const node = document.getElementById('spa-footer');
    node?.querySelectorAll('.cq-placeholder, meta, cq, .newpar').forEach(n => n.remove());
    document.getElementById('benchmark-toggle')?.classList.add('collapse');
    document.getElementById('assumptions-toggle')?.classList.add('collapse');
  };

  componentDidMount() {
    this.fetchExternalHTML();
  }

  render(): JSX.Element {
    return <div id={'spa-footer'} dangerouslySetInnerHTML={{ __html: this.state.footerContent }} />;
  }
}

export default SPAXFFooter;
